import { legacyGlobals } from '~/legacy/screens'
import { closeModal } from '~/legacy/runtime'
import { wizardCreateEcheancier, wizardCreateVersement } from '~/composables/useWizardCaisse'
import { wizardCreateEtudiant, wizardCreateParent, wizardCreateInscription, wizardValidateDocuments } from '~/composables/useWizardInscription'
import { submitForm, createMatiereFromUeForm } from '~/composables/useEntityForm'

/**
 * Le balisage de la maquette déclenche ses actions par des gestionnaires en ligne (onclick="goTo(…)").
 * Les fonctions correspondantes sont donc rendues accessibles à la page, comme dans la maquette :
 * celles reprises du HTML, puis celles que l'application fournit elle-même (écritures dans l'API, écrans à convertir).
 */
export default defineNuxtPlugin(() => {
  Object.assign(window, legacyGlobals, {
    goTo, openForm, deleteRow, closeModal, submitBulkReduction, createSecondSemestre,
    openPayLigneModal, openQuickVersement, openQuickVersementPicker, quickAddDocument, openAddEcueModal,
    // documents et exports : demandés au backend (aucune génération dans le navigateur)
    openBackendFile, downloadPdf, exportSoldesCSV, exportCaisseEtatsExcel, exportListeClasseExcel, printRecu, openOrPrintRecu,
    wizardCreateEcheancier, wizardCreateVersement, submitForm, createMatiereFromUeForm,
    wizardCreateEtudiant, wizardCreateParent, wizardCreateInscription, wizardValidateDocuments,
    handleGenerateBulletin, removeNotesColumn, saveNotesGrid, saveBulletinRow, saveAllBulletins,
  })
})
